import { render, staticRenderFns } from "./RichTextField.vue?vue&type=template&id=8ecb652a&"
import script from "./RichTextField.vue?vue&type=script&lang=ts&"
export * from "./RichTextField.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextField.vue?vue&type=style&index=0&id=8ecb652a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports